import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import { AuthService } from '../../common/API/AuthService';
import { useAuth } from '../../common/context/AuthProvider';
import PageContainer from '../../components/PageContainer';
import { Field, Form, Formik } from 'formik';
import { Link } from 'react-router-dom';
import Animated from '../../components/AnimatedComponent';
import Input from '../../components/forms/Input';
import Screen from '../../components/layout/Screen';
import ScrollableContainer from '../../components/ScrollableContainer';

const RegisterScreen = () => {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const formRef: any = useRef();

  const handleSubmit = () => {
    console.log(formRef.current.values);
    // console.log(formRef.current.resetForm());
    AuthService.register(formRef.current.values).then((res) => {
      console.log(res);
      // login(res);
    });
  };

  useEffect(() => {
    if (isLoggedIn) navigate('/home');
  }, [isLoggedIn]);

  return (
    <Screen
      screenOptions={{
        tabNavigator: {
          hide: false,
        },
      }}
    >
      <ScrollableContainer className='flex flex-col items-center justify-end pb-14 h-full'>
        <Animated.Component className='text-left w-full dark:text-white'>
          <h1 className='text-4xl font-bold mb-1 text-left w-full'>Sing in</h1>
          <p className='mb-5 text-left w-full'>Get ready it`s quick and easy!</p>
        </Animated.Component>

        <Formik
          innerRef={formRef}
          initialValues={{
            email: '',
            password: '',
            password_confirmation: '',
          }}
          onSubmit={() => {
            // console.log({ values, actions });
            // navigate('/home');
          }}
        >
          <Form className='w-full'>
            <span className='text-xs uppercase mb-2 block text-gray-500 dark:text-neutral-500'>
              Account information
            </span>{' '}
            <section className='bg-white dark:bg-neutral-800 rounded-lg w-full'>
              <Field name='email' placeholder='Email' component={Input} />
              <Field name='password' type='password' placeholder='Password' component={Input} />
              <Field name='password_confirmation' type='password' placeholder='Confirm password' component={Input} />
            </section>
            <Link to='/login' className='text-sm text-blue-500 dark:text-orange-500 mt-2 block'>
              Back to login.
            </Link>
          </Form>
        </Formik>

        <button
          className='block p-2.5 w-full text-sm bg-blue-500 dark:bg-orange-500 text-white rounded-lg mt-6'
          onClick={handleSubmit}
        >
          Sign in
        </button>
      </ScrollableContainer>
    </Screen>
  );
};

export default RegisterScreen;
